import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const MeatBallsMenuContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 226px;
    min-height: 52px;
    padding: 18px 0;

    background: ${Colors.WHITE};
    border-radius: 4px;
    box-shadow: 0 12px 20px rgba(0, 0, 0, 8%);
`;

export const MeatBallsAction = styled.div`
    cursor: pointer;

    display: flex;
    align-items: center;

    min-width: 226px;
    height: 36px;
    padding-left: 37px;

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Colors.Black.V50};

    :hover,
    :focus {
        background-color: ${Colors.Gray.V50};
    }
`;

// Aligns with MeatBallsAction text; matches the shared errorTextContainer type scale.
export const MeatBallsMenuError = styled.span`
    box-sizing: border-box;
    width: 226px;
    padding: 4px 16px 0 37px;

    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: ${Colors.Red.V150};
    text-align: left;
`;
